import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import T from '../../app/Locale';
import ComponentButton from '../../app2/Components/ComponentButton';
import ModalUpload from './ModalUpload';
const DocumentUploadButton = ({ products, title, classes }) => {
    const [showModal, toggleModal] = useState(false);
    const availableProducts = {};
    if (products) {
        products
            .filter((product) => product.canBeUploaded)
            .forEach((product) => {
            availableProducts[product.machineName] = product.title;
        });
    }
    return (_jsxs("div", { children: [showModal && (_jsx(ModalUpload, { content: T.translate('documents.upload.extern_content'), options: availableProducts, closeModal: () => toggleModal(false) })), _jsx(ComponentButton, { classes: classes, title: T.translate(title), onClick: () => toggleModal(true) })] }));
};
DocumentUploadButton.propTypes = {
    products: PropTypes.array,
    title: PropTypes.string,
    classes: PropTypes.string
};
export default DocumentUploadButton;
